import React, { useState } from 'react'
import { DateTime } from 'luxon'

import { TableRowProps, WithTableRowProps } from './interface'

export function withTableRow(Component: React.FC<TableRowProps>) {
  function WithTableRow({ ...props }: WithTableRowProps) {
    const [isShowSubRow, setIsShowSubRow] = useState<boolean>(false)

    function getMonth(month: number) {
      return !month
        ? ''
        : DateTime.fromObject({ month }).setLocale('th').monthLong
    }

    function formatDate(date: string) {
      return !date
        ? ''
        : DateTime.fromISO(date).setLocale('th').toFormat('dd LLLL yyyy')
    }

    function handleToggleShowSubRow() {
      setIsShowSubRow(!isShowSubRow)
    }

    const componentProps = {
      ...props.data,
      isShowSubRow,
      getMonth,
      formatDate,
      handleToggleShowSubRow,
    }

    return <Component {...componentProps} />
  }

  return WithTableRow
}
